// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1Tzl0ugBB5TEbd74inDbt-","fbWrap":"M_NJXr9SDPjRlurVzV2qp"};